import React, { useState, useEffect } from "react";
import VerifySecurityQuestions from "../VerifySecurityQuestions";
import UpdatePassword from "./UpdatePassword";
import signinImage from "../../assets/img/abanotes3.png";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");

  useEffect(() => {
    document.body.style.backgroundImage = `url(${signinImage})`;
    document.body.style.backgroundSize = "cover";


    return () => {
      document.body.style.backgroundImage = '';
    document.body.style.backgroundSize = '';
    };
  }, []);

  const handleNext = (verifiedEmail) => {
    setEmail(verifiedEmail);
    setStep(2);
  };

  return (
    <div style={{background:"none"}}>
      {step === 1 && <VerifySecurityQuestions onNext={handleNext} />}
      {step === 2 && <UpdatePassword email={email} />}
    </div>
  );
};

export default ForgotPassword;
